import {Button} from "antd";

export interface PagePdfProps{
    numberOfPages:number|undefined;
}
export function PagePdf (props:PagePdfProps){
    return<>
        <Button type={"primary"} >Totale pagine {props.numberOfPages}</Button>
    </>
}